<template>
<div id="register-step">
    <div class="row pt-4 register-step border-bottom adjust-padding ">

        <div class="col-12 pb-2 mb-2 px-0">
            <h6 class="c-nmidone bold caption">
                DADOS DA EMPRESA
            </h6>
        </div>
        <div class="col-12 pb-2 mb-1 px-0 border-bottom">
            <h6 @click="handleStepSelect('0')" :class="`${step == 0 ? `c-${getPrimaryColor}four bold` : 'c-ndarkfour regular'} mb-0 ${registerStep >= 0 ? 'pointer' : ''}`">
                Dados gerais
            </h6>
        </div>
        <div class="col-12 py-2 mb-1 px-0 border-bottom">
            <h6 @click="handleStepSelect('1')" :class="`${step == 1 ? `c-${getPrimaryColor}four bold` : 'c-ndarkfour regular'} mb-0 ${registerStep >= 1 ? 'pointer' : ''}`">
                Endereço
            </h6>
        </div>
        <div class="col-12 py-2 mb-1 px-0 border-bottom">
            <h6 @click="handleStepSelect('2')" :class="`${step == 2 ? `c-${getPrimaryColor}four bold` : 'c-ndarkfour regular'} mb-0 ${registerStep >= 2 ? 'pointer' : ''}`">
                Resp. pela operação
            </h6>
        </div>
        <div class="col-12 py-2 mb-2 px-0">
            <h6 @click="handleStepSelect('3')" :class="`${step == 3 ? `c-${getPrimaryColor}four bold` : 'c-ndarkfour regular'} mb-0 ${registerStep >= 3 ? 'pointer' : ''}`">
                Documentos
            </h6>
        </div>

    </div>

    <div class="row pt-4 register-step border-bottom adjust-padding ">

        <div class="col-12 pb-2 mb-1 px-0">
            <h6 class="c-nmidone bold caption">
                SÓCIOS
            </h6>
        </div>
        <div class="col-12 pb-2 mb-2 px-0">
            <h6 @click="handleStepSelect('5')" :class="`${step >= 5 ? `c-${getPrimaryColor}four bold` : 'c-ndarkfour regular'} ${registerStep >= 5 ? 'pointer' : ''}`">
                Sócios e procuradores
            </h6>
        </div>

    </div>
    <CancelRegister :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @cancelRegister="gotoStep" @saveChange="saveChanges"/>
</div>
</template>

<script>
import CancelRegister from '@/components/modals/CancelRegister'
export default {
    components: {
        CancelRegister,
    },
    data() {
        return {
            dialogVisible: false,
            selectedStep: '',
        }
    },
    computed: {
        step() {
            if (this.$route.path.includes('partner')) return 5
            if (this.$route.path.includes('message')) return -1
            const stepRoute = this.$route.path.substring(this.$route.path.length - 1)
            return stepRoute
        },
        stepProviderDocuments() {
            return this.$store.state.register.company.cnpj.companyType == 1 ? '4' : '3'
        },
        pointer() {
            return this.$store.state.register.company.cnpj.registerComplete != 0 ? 'pointer' : ''
        },
        registerStep() {
            return this.$store.state.register.company.cnpj.registerComplete == 0 ? this.$store.state.register.company.cnpj.registerStep : 5
        }
    },
    created() {
        this.selectedStep = this.$store.state.register.company.cnpj.registerStep
    },
    methods: {
        handleStepSelect(step) {
            /* if (step == 4 && !this.$route.path.includes('partner') || this.$route.path.slice(-1) != step) { */
            // if (this.$store.state.register.company.cnpj.registerComplete != 0) {
            if (this.registerStep >= step) {
                this.selectedStep = step
                if (this.$store.state.register.formIsChanged) {
                    this.dialogVisible = true
                } else {
                    this.gotoStep()
                }
            }
            // }
            /*  */
        },
        gotoStep() {  
            const route = this.selectedStep == 5 ? `/company/register/${this.$route.params.idCNPJ}/partner`
                : this.$route.path.includes('partner') || this.$route.path.includes('message')  ? `/company/register/${this.$route.params.idCNPJ}/${this.selectedStep}`
                : `${this.$route.path.slice(0, this.$route.path.length - 1)}${this.selectedStep}`
            if (this.$route.path != route) this.$router.push(route)
            this.dialogVisible = false
        },
        saveChanges() {
            this.$emit('saveChange')
            this.gotoStep()
        }
    }
}
</script>

<style lang="scss" scoped>
    .register-step {
        background-color: #FBFDFE;
        border-top-left-radius: 6px;
    }
    .adjust-padding {
        padding-left: 24px;
        padding-right: 24px;
        @media screen and (max-width: 1450px) {
            padding-left: 16px;
            padding-right: 16px;            
        }
    }
</style>